import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays, format } from 'date-fns';

import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

@Pipe({
  name: 'isPast'
})
export class IsPastPipe implements PipeTransform {
  transform(value: string): boolean {
    const today = format(legacyParse(new Date()), convertTokens('YYYY-MM-DD'));
    const date = format(legacyParse(value), convertTokens('YYYY-MM-DD'));
    return differenceInDays(legacyParse(today), legacyParse(date)) > 0;
  }
}
